import { z } from "zod";

export const WORD_EXPORT_PLACEHOLDER = "agent_answer";
export const WORD_EXPORT_PLACEHOLDER_TOKEN = "{{agent_answer}}";

export const ALLOWED_WORD_TEMPLATE_TYPES = [
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
] as const;

export const MAX_WORD_TEMPLATE_SIZE = 10 * 1024 * 1024;

export const UpdateWordExportConfigSchema = z.object({
  isEnabled: z.boolean()
});

export type UpdateWordExportConfigInput = z.infer<
  typeof UpdateWordExportConfigSchema
>;
